var _path, _rect, _rect2, _circle, _circle2, _circle3, _circle4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 78a26 26 0 0 1 51-7 20 20 0 0 1 30 18 18 18 0 0 1-4 35H92a24 24 0 0 1-4-46 26 26 0 0 1 7 0z",
    fill: "#fff",
    stroke: "#F97316",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 96,
    width: 84,
    height: 12,
    rx: 3,
    fill: "#FFEDD5",
    stroke: "#F97316",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 114,
    width: 84,
    height: 12,
    rx: 3,
    fill: "#FFF7ED",
    stroke: "#F97316",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 102,
    r: 2.4,
    fill: "#F59E0B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 120,
    r: 2.4,
    fill: "#F59E0B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 5,
    fill: "#F97316"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 52,
    r: 5,
    fill: "#F59E0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62 L92 78 M235 55 L182 74",
    stroke: "#FDBA74",
    strokeWidth: 1.6,
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.fffe90b219af016bec0dea810874a69c.svg";
export { ForwardRef as ReactComponent };